export default __webpack_public_path__ + "static/phone-fanout-30b81ca89413f7340a647c2152371c0b.png";